exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  min-height: calc(100vh - 215px);\n  width: 100%;\n}\n\n.image-uploader .ui-card-subtitle {\n  margin: 16px 0;\n  padding-left: 1em;\n}\n\n#image-uploader .page-content {\n  min-height: unset;\n  padding: 50px 0;\n}\n\n#image-uploader .logo-container {\n  padding: 0 8px;\n}\n\n#image-uploader .cpt-button {\n  background-color: white;\n  color: #212121;\n  border-color: #a0a0a0;\n  cursor: unset;\n  text-align: center;\n}\n\n#image-uploader .cpt-button-icon {\n  height: 24px;\n  width: 24px;\n  top: calc(50% - 12px);\n}\n\n#image-uploader .facebook-icon {\n  right: 42px;\n}\n\n#image-uploader .next-icon,\n#image-uploader .twitter-icon {\n  right: 12px;\n}\n\n#image-uploader .page-banner-container {\n  background-color: #A2DFF9;\n  padding-left: 24px;\n}\n\n#image-uploader .clickable-element:hover {\n  box-shadow: 0px 0px 20px 0px rgba(224,198,67,1);\n}\n\n@media screen and (max-width: 640px) {\n  #image-uploader .page-content {\n    min-height: unset;\n    padding: 16px 0;\n  }\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/image-uploader/image-uploader.component.css
// module id = ../../../../../src/app/components/organization/captive-portal/image-uploader/image-uploader.component.css
// module chunks = main